<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';

const store = useStore();
const { t } = useI18n();

const currentChat = computed(() => store.getters.getSelectedChat);

const taskExists = computed(() =>
  Boolean(currentChat.value?.custom_attributes?.task_exist)
);

const onNewTaskClick = async () => {
  if (taskExists.value) return;
  if (!currentChat.value?.id) return;

  const existingAttributes = currentChat.value.custom_attributes || {};
  try {
    // Update custom_attributes - this will trigger conversation_updated webhook
    await store.dispatch('updateCustomAttributes', {
      conversationId: currentChat.value.id,
      customAttributes: { ...existingAttributes, task_exist: true },
    });
  } catch (error) {
    useAlert(
      error?.message ? error.message : t('CONTACT_PANEL.NEW_TASK_ERROR')
    );
  }
};
</script>

<template>
  <NextButton
    v-tooltip.left="
      taskExists
        ? t('CONTACT_PANEL.TASK_ALREADY_CREATED')
        : t('CONTACT_PANEL.NEW_TASK')
    "
    :label="t('CONTACT_PANEL.NEW_TASK')"
    :icon="taskExists ? 'i-lucide-check' : 'i-lucide-plus'"
    :disabled="taskExists"
    :class="{ 'opacity-100': taskExists }"
    data-testid="conversation-header-new-task"
    slate
    faded
    sm
    @click="onNewTaskClick"
  />
</template>
